import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MoreHorizontal, X } from 'lucide-react';

/* TopPillNav — design-lock navigation: never more than 5 big buttons,
   each a picture (thin line icon) and one word. The 5th is More, which
   opens a full sheet of everything else. Desktop only (bottom bar covers
   phone and iPad). */
export const TopPillNav = ({ primary, more }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  const isOn = (p) => (p === '/dashboard' ? location.pathname === p : location.pathname.startsWith(p));
  return (
    <>
      <nav className="rvk-mainnav" aria-label="Main" data-testid="top-pill-nav">
        {primary.slice(0, 4).map((it) => {
          const I = it.icon;
          return (
            <Link key={it.path} to={it.path} className={`rvk-nb ${isOn(it.path) ? 'on' : ''}`}
              data-testid={`pill-nav-${it.label.toLowerCase()}`}>
              {I && <I size={20} strokeWidth={1.7} />}<span>{it.label}</span>
            </Link>
          );
        })}
        {more.length > 0 && (
          <button type="button" className="rvk-nb" onClick={() => setOpen(true)} data-testid="pill-nav-more">
            <MoreHorizontal size={20} strokeWidth={1.7} /><span>More</span>
          </button>
        )}
      </nav>
      {open && (
        <div className="fixed inset-0 z-[80] flex items-start justify-center" style={{ background: 'rgba(41,21,37,.45)' }}
          onClick={() => setOpen(false)} data-testid="pill-more-overlay">
          <div className="rvk-card w-full max-w-3xl mt-16 mx-4 p-6 max-h-[75vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}
            role="dialog" aria-label="More" data-testid="pill-more-sheet">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-2xl" style={{ fontFamily: "'Bodoni Moda', Georgia, serif" }}>Where do you want to go?</h2>
              <button type="button" className="rvk-pill" style={{ height: 36 }} onClick={() => setOpen(false)} data-testid="pill-more-close">
                <X size={14} /> Close
              </button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {more.map((it) => {
                const I = it.icon;
                return (
                  <Link key={it.path + it.label} to={it.path} onClick={() => setOpen(false)}
                    className="rvk-card flex items-center gap-3 p-4 hover:border-[#B99A65] transition-colors"
                    style={{ textDecoration: 'none', color: '#2B1F27' }}
                    data-testid={`pill-more-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
                    {I && <I size={20} strokeWidth={1.7} style={{ color: '#7E5F2E', flexShrink: 0 }} />}
                    <span className="text-sm font-medium">{it.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
